module.exports = __webpack_public_path__ + "img/mbank-quiz-start.882cbee0.jpg";